import React, { useState, useEffect } from 'react';
import { apiRequest } from '../utils/api';

const EditCustomer = ({ customer, onUpdate, onCancel }) => {
  const [activeTab, setActiveTab] = useState('basic');
  const [vpsList, setVpsList] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    isActive: true,
    // Store information
    apiUrl: '',
    storeNameEn: '', storeNameAr: '', storeNameShortEn: '', storeNameShortAr: '',
    storeEmailInfo: '', storeEmailSupport: '', storeEmailAdmin: '', storeEmailPrivacy: '',
    storePhonePrimary: '', storePhoneSecondary: '',
    storeAddressEn: '', storeAddressAr: '', storeAddressLine2: '',
    storeCountry: '', storeCity: '', storeFrontendUrl: '',
    storeDescriptionEn: '', storeDescriptionAr: '',
    storeTaglineEn: '', storeTaglineAr: '',
    // Store colors
    storePrimaryColor: '', storePrimaryColorHsl: '',
    storeSecondaryColor: '', storeSecondaryColorHsl: '',
    storeAccentColor: '', storeAccentColorHsl: '',
    storeBackgroundColor: '', storeBackgroundColorHsl: '',
    // Coming soon
    storeComingSoonDescriptionEn: '', storeComingSoonDescriptionAr: '',
    storeComingSoonTaglineEn: '', storeComingSoonTaglineAr: '',
    // MongoDB
    mongodbUri: '', mongodbDbName: '',
    // R2
    r2AccessKeyId: '', r2SecretAccessKey: '', r2BucketName: '',
    r2PublicUrl: '', r2Endpoint: '', r2PublicBaseUrl: '',
    // Telegram
    telegramBotToken: '', telegramBotUsername: '',
    // Admin
    adminDefaultEmail: '', adminDefaultPassword: '', adminDefaultName: '', adminDefaultPhone: '',
    // Business type
    businessType: '',
    // VPS Reference
    vps: '',
    // Store Hours
    storeHoursWeekdaysEn: '',
    storeHoursWeekdaysAr: '',
    storeHoursWeekendEn: '',
    storeHoursWeekendAr: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const fetchVPSs = async () => {
    try {
      const data = await apiRequest('/admin/vps?limit=100');
      if (data && data.success) {
        setVpsList(data.data || []);
      }
    } catch (error) {
      console.error('Error fetching VPSs:', error);
    }
  };

  useEffect(() => {
    fetchVPSs();
  }, []);

  useEffect(() => {
    if (customer) {
      setFormData({
        name: customer.name || '',
        email: customer.email || '',
        isActive: customer.isActive !== undefined ? customer.isActive : true,
        apiUrl: customer.apiUrl || '',
        storeNameEn: customer.storeNameEn || '',
        storeNameAr: customer.storeNameAr || '',
        storeNameShortEn: customer.storeNameShortEn || '',
        storeNameShortAr: customer.storeNameShortAr || '',
        storeEmailInfo: customer.storeEmailInfo || '',
        storeEmailSupport: customer.storeEmailSupport || '',
        storeEmailAdmin: customer.storeEmailAdmin || '',
        storeEmailPrivacy: customer.storeEmailPrivacy || '',
        storePhonePrimary: customer.storePhonePrimary || '',
        storePhoneSecondary: customer.storePhoneSecondary || '',
        storeAddressEn: customer.storeAddressEn || '',
        storeAddressAr: customer.storeAddressAr || '',
        storeAddressLine2: customer.storeAddressLine2 || '',
        storeCountry: customer.storeCountry || '',
        storeCity: customer.storeCity || '',
        storeFrontendUrl: customer.storeFrontendUrl || '',
        storeDescriptionEn: customer.storeDescriptionEn || '',
        storeDescriptionAr: customer.storeDescriptionAr || '',
        storeTaglineEn: customer.storeTaglineEn || '',
        storeTaglineAr: customer.storeTaglineAr || '',
        storePrimaryColor: customer.storePrimaryColor || '',
        storePrimaryColorHsl: customer.storePrimaryColorHsl || '',
        storeSecondaryColor: customer.storeSecondaryColor || '',
        storeSecondaryColorHsl: customer.storeSecondaryColorHsl || '',
        storeAccentColor: customer.storeAccentColor || '',
        storeAccentColorHsl: customer.storeAccentColorHsl || '',
        storeBackgroundColor: customer.storeBackgroundColor || '',
        storeBackgroundColorHsl: customer.storeBackgroundColorHsl || '',
        storeComingSoonDescriptionEn: customer.storeComingSoonDescriptionEn || '',
        storeComingSoonDescriptionAr: customer.storeComingSoonDescriptionAr || '',
        storeComingSoonTaglineEn: customer.storeComingSoonTaglineEn || '',
        storeComingSoonTaglineAr: customer.storeComingSoonTaglineAr || '',
        mongodbUri: customer.mongodbUri || '',
        mongodbDbName: customer.mongodbDbName || '',
        r2AccessKeyId: customer.r2AccessKeyId || '',
        r2SecretAccessKey: customer.r2SecretAccessKey || '',
        r2BucketName: customer.r2BucketName || '',
        r2PublicUrl: customer.r2PublicUrl || '',
        r2Endpoint: customer.r2Endpoint || '',
        r2PublicBaseUrl: customer.r2PublicBaseUrl || '',
        telegramBotToken: customer.telegramBotToken || '',
        telegramBotUsername: customer.telegramBotUsername || '',
        adminDefaultEmail: customer.adminDefaultEmail || '',
        adminDefaultPassword: customer.adminDefaultPassword || '',
        adminDefaultName: customer.adminDefaultName || '',
        adminDefaultPhone: customer.adminDefaultPhone || '',
        businessType: customer.businessType || '',
        vps: customer.vps?._id || customer.vps || '',
        storeHoursWeekdaysEn: customer.storeHoursWeekdaysEn || '',
        storeHoursWeekdaysAr: customer.storeHoursWeekdaysAr || '',
        storeHoursWeekendEn: customer.storeHoursWeekendEn || '',
        storeHoursWeekendAr: customer.storeHoursWeekendAr || '',
        openaiProjectId: customer.openaiProjectId || '',
      });
    }
  }, [customer]);

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Clean up empty strings to avoid sending them
      const cleanedData = Object.keys(formData).reduce((acc, key) => {
        if (formData[key] !== '') {
          acc[key] = formData[key];
        }
        return acc;
      }, {});

      const data = await apiRequest(`/admin/customers/${customer._id}`, {
        method: 'PUT',
        body: JSON.stringify(cleanedData),
      });

      if (data.success) {
        setSuccess('تم تحديث بيانات العميل بنجاح');
        setTimeout(() => {
          if (onUpdate) onUpdate(data.data);
        }, 1000);
      } else {
        setError(data.message || data.errors?.join(', ') || 'حدث خطأ أثناء تحديث العميل');
      }
    } catch (error) {
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setLoading(false);
    }
  };

  const tabs = [
    { id: 'basic', label: 'البيانات الأساسية' },
    { id: 'store', label: 'معلومات المتجر' },
    { id: 'colors', label: 'الألوان' },
    { id: 'coming-soon', label: 'صفحة قريباً' },
    { id: 'mongodb', label: 'MongoDB' },
    { id: 'r2', label: 'R2 / Cloudflare' },
    { id: 'telegram', label: 'Telegram' },
    { id: 'admin', label: 'الإدارة' },
    { id: 'business', label: 'نوع النشاط' },
    { id: 'vps', label: 'VPS' },
    { id: 'store-hours', label: 'ساعات العمل' },
    { id: 'openai', label: 'OpenAI' },
  ];

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="card-title">تعديل بيانات العميل</h2>
        <button className="btn btn-secondary btn-sm" onClick={onCancel}>
          إلغاء
        </button>
      </div>

      {/* Tabs */}
      <div className="tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <form onSubmit={handleSubmit}>
        {/* Basic Info Tab */}
        {activeTab === 'basic' && (
          <div>
            <div className="form-group">
              <label className="form-label">الاسم *</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">البريد الإلكتروني *</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                  style={{ marginLeft: '0.5rem' }}
                />
                العميل نشط
              </label>
            </div>
          </div>
        )}

        {/* Store Information Tab - Reusing CreateCustomer structure */}
        {activeTab === 'store' && (
          <div>
            <div className="form-group">
              <label className="form-label">API URL</label>
              <input
                type="url"
                name="apiUrl"
                className="form-control"
                value={formData.apiUrl}
                onChange={handleChange}
                placeholder="https://api.example.com"
              />
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>أسماء المتجر</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">اسم المتجر (إنجليزي)</label>
                <input type="text" name="storeNameEn" className="form-control" value={formData.storeNameEn} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">اسم المتجر (عربي)</label>
                <input type="text" name="storeNameAr" className="form-control" value={formData.storeNameAr} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">اسم المتجر المختصر (إنجليزي)</label>
                <input type="text" name="storeNameShortEn" className="form-control" value={formData.storeNameShortEn} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">اسم المتجر المختصر (عربي)</label>
                <input type="text" name="storeNameShortAr" className="form-control" value={formData.storeNameShortAr} onChange={handleChange} />
              </div>
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>البريد الإلكتروني</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">بريد المعلومات</label>
                <input type="email" name="storeEmailInfo" className="form-control" value={formData.storeEmailInfo} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">بريد الدعم</label>
                <input type="email" name="storeEmailSupport" className="form-control" value={formData.storeEmailSupport} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">بريد الإدارة</label>
                <input type="email" name="storeEmailAdmin" className="form-control" value={formData.storeEmailAdmin} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">بريد الخصوصية</label>
                <input type="email" name="storeEmailPrivacy" className="form-control" value={formData.storeEmailPrivacy} onChange={handleChange} />
              </div>
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>الهواتف</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">الهاتف الأساسي</label>
                <input type="text" name="storePhonePrimary" className="form-control" value={formData.storePhonePrimary} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">الهاتف الثانوي</label>
                <input type="text" name="storePhoneSecondary" className="form-control" value={formData.storePhoneSecondary} onChange={handleChange} />
              </div>
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>العنوان</h4>
            <div className="form-group">
              <label className="form-label">العنوان (إنجليزي)</label>
              <textarea name="storeAddressEn" className="form-control" rows="2" value={formData.storeAddressEn} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">العنوان (عربي)</label>
              <textarea name="storeAddressAr" className="form-control" rows="2" value={formData.storeAddressAr} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">العنوان - السطر الثاني</label>
              <input type="text" name="storeAddressLine2" className="form-control" value={formData.storeAddressLine2} onChange={handleChange} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">الدولة</label>
                <input type="text" name="storeCountry" className="form-control" value={formData.storeCountry} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">المدينة</label>
                <input type="text" name="storeCity" className="form-control" value={formData.storeCity} onChange={handleChange} />
              </div>
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>الوصف</h4>
            <div className="form-group">
              <label className="form-label">الوصف (إنجليزي)</label>
              <textarea name="storeDescriptionEn" className="form-control" rows="3" value={formData.storeDescriptionEn} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">الوصف (عربي)</label>
              <textarea name="storeDescriptionAr" className="form-control" rows="3" value={formData.storeDescriptionAr} onChange={handleChange} />
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>الشعارات</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">الشعار (إنجليزي)</label>
                <input type="text" name="storeTaglineEn" className="form-control" value={formData.storeTaglineEn} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">الشعار (عربي)</label>
                <input type="text" name="storeTaglineAr" className="form-control" value={formData.storeTaglineAr} onChange={handleChange} />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">رابط الواجهة الأمامية</label>
              <input type="url" name="storeFrontendUrl" className="form-control" value={formData.storeFrontendUrl} onChange={handleChange} placeholder="https://store.example.com" />
            </div>
          </div>
        )}

        {/* Colors Tab */}
        {activeTab === 'colors' && (
          <div>
            <h4 style={{ marginTop: '0', marginBottom: '1rem', color: '#667eea' }}>الألوان الأساسية</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">اللون الأساسي</label>
                <input type="text" name="storePrimaryColor" className="form-control" value={formData.storePrimaryColor} onChange={handleChange} placeholder="#667eea" />
              </div>
              <div className="form-group">
                <label className="form-label">اللون الأساسي (HSL)</label>
                <input type="text" name="storePrimaryColorHsl" className="form-control" value={formData.storePrimaryColorHsl} onChange={handleChange} placeholder="hsl(252, 79%, 67%)" />
              </div>
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>الألوان الثانوية</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">اللون الثانوي</label>
                <input type="text" name="storeSecondaryColor" className="form-control" value={formData.storeSecondaryColor} onChange={handleChange} placeholder="#764ba2" />
              </div>
              <div className="form-group">
                <label className="form-label">اللون الثانوي (HSL)</label>
                <input type="text" name="storeSecondaryColorHsl" className="form-control" value={formData.storeSecondaryColorHsl} onChange={handleChange} placeholder="hsl(270, 50%, 60%)" />
              </div>
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>لون التمييز</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">لون التمييز</label>
                <input type="text" name="storeAccentColor" className="form-control" value={formData.storeAccentColor} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">لون التمييز (HSL)</label>
                <input type="text" name="storeAccentColorHsl" className="form-control" value={formData.storeAccentColorHsl} onChange={handleChange} />
              </div>
            </div>

            <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem', color: '#667eea' }}>لون الخلفية</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">لون الخلفية</label>
                <input type="text" name="storeBackgroundColor" className="form-control" value={formData.storeBackgroundColor} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">لون الخلفية (HSL)</label>
                <input type="text" name="storeBackgroundColorHsl" className="form-control" value={formData.storeBackgroundColorHsl} onChange={handleChange} />
              </div>
            </div>
          </div>
        )}

        {/* Coming Soon Tab */}
        {activeTab === 'coming-soon' && (
          <div>
            <div className="form-group">
              <label className="form-label">الوصف (إنجليزي)</label>
              <textarea name="storeComingSoonDescriptionEn" className="form-control" rows="4" value={formData.storeComingSoonDescriptionEn} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">الوصف (عربي)</label>
              <textarea name="storeComingSoonDescriptionAr" className="form-control" rows="4" value={formData.storeComingSoonDescriptionAr} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">الشعار (إنجليزي)</label>
              <input type="text" name="storeComingSoonTaglineEn" className="form-control" value={formData.storeComingSoonTaglineEn} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">الشعار (عربي)</label>
              <input type="text" name="storeComingSoonTaglineAr" className="form-control" value={formData.storeComingSoonTaglineAr} onChange={handleChange} />
            </div>
          </div>
        )}

        {/* MongoDB Tab */}
        {activeTab === 'mongodb' && (
          <div>
            <div className="form-group">
              <label className="form-label">MongoDB URI</label>
              <input type="text" name="mongodbUri" className="form-control" value={formData.mongodbUri} onChange={handleChange} placeholder="mongodb://..." />
            </div>
            <div className="form-group">
              <label className="form-label">اسم قاعدة البيانات</label>
              <input type="text" name="mongodbDbName" className="form-control" value={formData.mongodbDbName} onChange={handleChange} />
            </div>
          </div>
        )}

        {/* R2 Tab */}
        {activeTab === 'r2' && (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">Access Key ID</label>
                <input type="text" name="r2AccessKeyId" className="form-control" value={formData.r2AccessKeyId} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">Secret Access Key</label>
                <input type="text" name="r2SecretAccessKey" className="form-control" value={formData.r2SecretAccessKey} onChange={handleChange} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">اسم الـ Bucket</label>
              <input type="text" name="r2BucketName" className="form-control" value={formData.r2BucketName} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">Public URL</label>
              <input type="url" name="r2PublicUrl" className="form-control" value={formData.r2PublicUrl} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">Endpoint</label>
              <input type="url" name="r2Endpoint" className="form-control" value={formData.r2Endpoint} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">Public Base URL</label>
              <input type="url" name="r2PublicBaseUrl" className="form-control" value={formData.r2PublicBaseUrl} onChange={handleChange} />
            </div>
          </div>
        )}

        {/* Telegram Tab */}
        {activeTab === 'telegram' && (
          <div>
            <div className="form-group">
              <label className="form-label">Bot Token</label>
              <input type="text" name="telegramBotToken" className="form-control" value={formData.telegramBotToken} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">Bot Username</label>
              <input type="text" name="telegramBotUsername" className="form-control" value={formData.telegramBotUsername} onChange={handleChange} />
            </div>
          </div>
        )}

        {/* Admin Tab */}
        {activeTab === 'admin' && (
          <div>
            <div className="form-group">
              <label className="form-label">البريد الإلكتروني الافتراضي</label>
              <input type="email" name="adminDefaultEmail" className="form-control" value={formData.adminDefaultEmail} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">كلمة المرور الافتراضية</label>
              <input type="password" name="adminDefaultPassword" className="form-control" value={formData.adminDefaultPassword} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">الاسم الافتراضي</label>
              <input type="text" name="adminDefaultName" className="form-control" value={formData.adminDefaultName} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">الهاتف الافتراضي</label>
              <input type="text" name="adminDefaultPhone" className="form-control" value={formData.adminDefaultPhone} onChange={handleChange} />
            </div>
          </div>
        )}

        {/* Business Type Tab */}
        {activeTab === 'business' && (
          <div>
            <div className="form-group">
              <label className="form-label">نوع النشاط</label>
              <select name="businessType" className="form-control" value={formData.businessType} onChange={handleChange}>
                <option value="">اختر نوع النشاط</option>
                <option value="electronics">إلكترونيات</option>
                <option value="clothes">ملابس</option>
                <option value="home-accessories">إكسسوارات منزلية</option>
              </select>
            </div>
          </div>
        )}

        {/* VPS Tab */}
        {activeTab === 'vps' && (
          <div>
            <div className="form-group">
              <label className="form-label">خادم VPS</label>
              <select
                name="vps"
                className="form-control"
                value={formData.vps}
                onChange={handleChange}
              >
                <option value="">لا يوجد (اختياري)</option>
                {vpsList.map((vps) => (
                  <option key={vps._id} value={vps._id}>
                    {vps.ip} {vps.provider ? `(${vps.provider})` : ''}
                  </option>
                ))}
              </select>
              <small style={{ color: '#666', display: 'block', marginTop: '0.5rem' }}>
                اختر خادم VPS مرتبط بهذا العميل. يمكن لعدة عملاء مشاركة نفس الخادم VPS.
              </small>
            </div>
          </div>
        )}

        {/* Store Hours Tab */}
        {activeTab === 'store-hours' && (
          <div>
            <div className="form-group">
              <label className="form-label">ساعات العمل - أيام الأسبوع (إنجليزي)</label>
              <input
                type="text"
                className="form-control"
                name="storeHoursWeekdaysEn"
                value={formData.storeHoursWeekdaysEn}
                onChange={handleChange}
                placeholder="Sunday - Thursday: 9:00 - 18:00"
              />
            </div>
            <div className="form-group">
              <label className="form-label">ساعات العمل - أيام الأسبوع (عربي)</label>
              <input
                type="text"
                className="form-control"
                name="storeHoursWeekdaysAr"
                value={formData.storeHoursWeekdaysAr}
                onChange={handleChange}
                placeholder="الأحد - الخميس: 9:00 - 18:00"
              />
            </div>
            <div className="form-group">
              <label className="form-label">ساعات العمل - نهاية الأسبوع (إنجليزي)</label>
              <input
                type="text"
                className="form-control"
                name="storeHoursWeekendEn"
                value={formData.storeHoursWeekendEn}
                onChange={handleChange}
                placeholder="Friday - Saturday: 10:00 - 16:00"
              />
            </div>
            <div className="form-group">
              <label className="form-label">ساعات العمل - نهاية الأسبوع (عربي)</label>
              <input
                type="text"
                className="form-control"
                name="storeHoursWeekendAr"
                value={formData.storeHoursWeekendAr}
                onChange={handleChange}
                placeholder="الجمعة - السبت: 10:00 - 16:00"
              />
            </div>
          </div>
        )}

        {/* OpenAI Tab */}
        {activeTab === 'openai' && (
          <div>
            <div className="form-group">
              <label className="form-label">OpenAI Project ID</label>
              <input
                type="text"
                className="form-control"
                name="openaiProjectId"
                value={formData.openaiProjectId || ''}
                onChange={handleChange}
                placeholder="proj_xxxxxxxxxxxxxxxxxxxxxx"
              />
              <small className="form-text text-muted">
                معرف المشروع الخاص بـ OpenAI لهذا العميل (اختياري). يُستخدم لتتبع التكاليف وخصمها من رصيد OpenAI.
              </small>
            </div>
          </div>
        )}

        {error && (
          <div className="alert alert-danger">
            <span>❌</span>
            <span>{error}</span>
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            <span>✅</span>
            <span>{success}</span>
          </div>
        )}

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid var(--gray-200)' }}>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            إلغاء
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'جاري التحديث...' : 'حفظ التغييرات'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCustomer;

